export function roundTo(num: number, digitsAfterComma: number): number {
  const multiplier = 10 ** digitsAfterComma;
  return Math.round(num * multiplier) / multiplier;
}
